import { render, staticRenderFns } from "./constructionList.vue?vue&type=template&id=5f8978fa&scoped=true&"
import script from "./constructionList.vue?vue&type=script&lang=js&"
export * from "./constructionList.vue?vue&type=script&lang=js&"
import style0 from "./constructionList.vue?vue&type=style&index=0&id=5f8978fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8978fa",
  null
  
)

export default component.exports